// import './CountryCode.less';
import './CountryCode.less';

export const prefix = 'bm-c-country-code';

export const modalPrefix = 'bm-c-country-code-modal';

export { default } from './CountryCode';
